module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n4n6r9n-644f4689a800004ab586a6bef678c825.svg";